module.exports = __webpack_public_path__ + "img/icon-editor.c21f9b52.svg";